import { ApiResponse } from '@/domain';
import { PaymentTransaction } from '@/domain/payments/payments';
import { InstallmentPlanInfo } from '@/domain/subscriptions/installments';
import { CreateBillingPeriodDto, ModifyBillingPeriodDto, SubscriptionData } from '@/domain/subscriptions/subscriptions';
import { backendApi } from '../backendApi';

export const subscriptionsApi = {
  // Create, update, delete
  createBillingPeriodPayment: (contractId: string, billingId: string) =>
    backendApi.post<ApiResponse<{ payment: PaymentTransaction }>>(`/api/v1/orch/agreements/${contractId}/billing-periods/${billingId}/payments`).then((res) => res.data),

  createBillingPeriod: (subscriptionId: string, data: CreateBillingPeriodDto) =>
    backendApi.post<ApiResponse<PaymentTransaction>>(`/api/v1/orch/subscription/${subscriptionId}/billingPeriod`, data).then((res) => res.data),

  createMultiSubscriptionPayment: (subscriptionId: string, data: { billingPeriodIds: string[] }) =>
    backendApi.post<ApiResponse<{ payment: PaymentTransaction }>>(`/api/v1/orch/subscription/${subscriptionId}/payments`, data).then((res) => res.data),

  createCustomSubscriptionPayment: (subscriptionId: string, data: { billingPeriodIds: string[], installments: number, installmentAmount: number }) =>
    backendApi.post<ApiResponse<void>>(`/api/v1/orch/subscription/${subscriptionId}/custom-payments`, data).then((res) => res.data),

  deleteBillingPeriod: (subscriptionId: string, billingPeriodId: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/subscriptions/${subscriptionId}/billing-periods/${billingPeriodId}`).then((res) => res.data),

  deleteBillingPeriods: (billingPeriods: { subscriptionId: string; billingPeriodId: string }[]) =>
    backendApi.post<ApiResponse<void>>(`/api/v1/subscriptions/bulk/delete`, { billingPeriods }).then((res) => res.data),

  modifyBillingPeriod: (subscriptionId: string, billingPeriodId: string, data: ModifyBillingPeriodDto) =>
    backendApi.put<ApiResponse<void>>(`/api/v1/subscriptions/${subscriptionId}/billing-periods/${billingPeriodId}`, data).then((res) => res.data),

  updatePaymentDescription: (subscriptionId: string, billingPeriodId: string, paymentId: string, description: string | null) =>
    backendApi.patch<ApiResponse<void>>(`/api/v1/subscriptions/${subscriptionId}/billing-periods/${billingPeriodId}/payments/${paymentId}`, { description }).then((res) => res.data),

  // Read
  getSubscriptions: (contractId: string) =>
    backendApi.get<ApiResponse<SubscriptionData[]>>(`/api/v1/data/agreements/${contractId}/subscriptions`).then((res) => res.data.data),

  getInstallments: (contractId: string) =>
    backendApi.get<ApiResponse<InstallmentPlanInfo[]>>(`/api/v1/data/agreements/${contractId}/installments`).then((res) => res.data.data),

  generateInstallment: (contractId: string, planId: string) =>
    backendApi.post<ApiResponse<PaymentTransaction>>(`/api/v1/orch/agreements/${contractId}/installments/${planId}/payments`).then((res) => res.data),
};
